import { Helmet } from "react-helmet-async";
import { WebPageJsonLd } from "@/components/seo/WebPageJsonLd";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const HIPAANotice = () => (
  <>
    <Helmet>
      <title>HIPAA Notice of Privacy Practices | Elara Health</title>
      <meta name="description" content="Elara Health's HIPAA Notice of Privacy Practices — how protected health information is used, disclosed, and safeguarded." />
      <link rel="canonical" href="https://elarahealth.life/hipaa" />
      <meta property="og:title" content="HIPAA Notice of Privacy Practices | Elara Health" />
      <meta property="og:url" content="https://elarahealth.life/hipaa" />
    </Helmet>
    <WebPageJsonLd
      path="/hipaa"
      name={"HIPAA Notice of Privacy Practices"}
      description={"Elara Health's HIPAA Notice of Privacy Practices — how protected health information is used, disclosed, and safeguarded."}
    />
    <Navbar />
    <main className="min-h-screen pt-24 pb-16">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="font-display text-4xl md:text-5xl text-foreground mb-6">HIPAA Notice of Privacy Practices</h1>
        <div className="prose prose-lg text-muted-foreground space-y-4">
          <p><em>Effective: {new Date().toLocaleDateString("en-US", { month: "long", year: "numeric" })}</em></p>
          <p>
            This notice describes how medical information about you may be used and disclosed,
            and how you can access this information. Please review it carefully.
          </p>
          <h2 className="font-display text-2xl text-foreground">Your Health Information Rights</h2>
          <p>You have the right to request restrictions on certain uses of your health information, receive confidential communications, inspect and obtain a copy of your health records, and request amendments.</p>
          <h2 className="font-display text-2xl text-foreground">Our Responsibilities</h2>
          <p>We are required by law to maintain the privacy of your protected health information, provide you with this notice, and follow the terms of this notice currently in effect.</p>
          <h2 className="font-display text-2xl text-foreground">Uses & Disclosures</h2>
          <p>We may use or disclose your health information for treatment, payment, and healthcare operations. Other uses require your written authorization.</p>
          <p>For questions or complaints, contact our Privacy Officer at <a href="mailto:privacy@elarahealth.life" className="text-champagne hover:underline">privacy@elarahealth.life</a>.</p>
        </div>
      </div>
    </main>
    <Footer />
  </>
);

export default HIPAANotice;
